import { Dispatch, SetStateAction } from 'react'
import { Button, DialogActions, DialogContent, DialogContentText, useTheme } from '@mui/material'

import DialogWithTitle from '../../../../components/dialog-with-title'

import useStyles from './index.styles'

interface IProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  selectedUsers: IUserType[]
  onRemove: () => Promise<void>
  chainModals: boolean
  setChainModals: Dispatch<SetStateAction<boolean>>
}

const RemoveModal = ({ open, setOpen, selectedUsers, onRemove, chainModals, setChainModals }: IProps) => {
  const classes = useStyles
  const theme = useTheme()

  const handleCancel = () => {
    setOpen(false)
    if (chainModals) {
      setChainModals(false)
    }
  }

  return (
    <DialogWithTitle title={`Remove From Account? ${chainModals ? '(1/2)' : ''}`} open={open} setOpen={setOpen}>
      <DialogContent>
        <DialogContentText sx={classes.dialogText}>These people can be successfully removed:</DialogContentText>

        {selectedUsers.map((user) => (
          <DialogContentText key={user.id} className="fs-exclude">
            {user.information?.first && user.information?.last ? `${user.information?.first} ${user.information?.last}` : user.email}
          </DialogContentText>
        ))}

        <DialogContentText sx={{ ...classes.dialogText(theme), marginTop: 2 }}>They will no longer have access to this account.</DialogContentText>

        <DialogActions>
          <Button variant="outlined" onClick={handleCancel}>
            Keep
          </Button>
          <Button variant="contained" onClick={onRemove} color="primary">
            Remove
          </Button>
        </DialogActions>
      </DialogContent>
    </DialogWithTitle>
  )
}

export default RemoveModal
